import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Tooltip, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { publishMessages } from '../publish-messages';

interface UploadFailedErrorDetailsIconProps {
  /** API error message from failed upload data, if present. */
  error?: string;
  /** API error code from failed upload data, if present. */
  errorCode?: string;
}

/**
 * Info icon with tooltip showing failed-upload error message and/or code.
 */
export function UploadFailedErrorDetailsIcon({
  error,
  errorCode,
}: UploadFailedErrorDetailsIconProps) {
  const { $t } = useIntl();

  if (!error && !errorCode) {
    return null;
  }

  return (
    <Tooltip
      title={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          {error ? (
            <Typography variant="body2" component="span">
              {error}
            </Typography>
          ) : null}
          {errorCode ? (
            <Typography variant="caption" component="span">
              {$t(publishMessages.chipErrorCode, { errorCode })}
            </Typography>
          ) : null}
        </Box>
      }
    >
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'error.main',
          cursor: 'default',
        }}
      >
        <ErrorOutlineIcon fontSize="small" color="inherit" />
      </Box>
    </Tooltip>
  );
}
